import { CustomFontProperties } from 'common/utils/fontsUtils'
import { FaqInterface } from 'src/shared/entities/faq/faq.schema'

export const getFaqFontProperties = (entity: FaqInterface) => {
  return entity.titleFontFamily
    ? [
        {
          fontFamily: entity.titleFontFamily,
          fontStyle: entity.titleFontStyle,
          fontWeight: entity.titleFontWeight,
        },
      ]
    : []
}

export const getFaqCustomFontProperties = (entity: FaqInterface) => {
  const customFonts: CustomFontProperties[] = []
  // that's not a mistake, we have titleFontFamily and fontFileId
  if (entity.titleFontFamily && entity.fontFileId) {
    customFonts.push({
      fontFamily: entity.titleFontFamily,
      fontFileId: entity.fontFileId,
    })
  }

  if (entity.mobileTitleFontFamily && entity.mobileFontFileId) {
    customFonts.push({
      fontFamily: entity.mobileTitleFontFamily,
      fontFileId: entity.mobileFontFileId,
    })
  }
  return customFonts
}
